import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getUsersPermissions, ApiUserPermissions } from 'store';
import { fetchUsersPermissions, updateUserPermissions } from 'services';
import { useAppDispatch, useAppSelector } from 'hooks';
import { AntSelect } from 'components/common';
import { Namespace } from 'enums';

import { PermissionEditor } from './PermissionEditor';

export const PermissionsPage = () => {
  const { t } = useTranslation(Namespace.Settings);
  const dispatch = useAppDispatch();
  const usersPermissions = useAppSelector(getUsersPermissions);
  const [selectedUser, setSelectedUser] = useState<string>();

  const userPermissionOptions = useMemo(() => {
    return usersPermissions?.map(({ displayName, login }) => ({ label: displayName, value: login }));
  }, [usersPermissions]);

  const selectedUserPermissions = useMemo(() => {
    return usersPermissions?.find(({ login }) => login === selectedUser);
  }, [usersPermissions, selectedUser]);

  const handleSavePermission = useCallback(
    (apiUserPermissions: ApiUserPermissions) => {
      dispatch(updateUserPermissions(apiUserPermissions));
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(fetchUsersPermissions());
  }, [dispatch]);

  return (
    <>
      <AntSelect
        loading={!usersPermissions.length}
        style={{ maxWidth: 400 }}
        value={selectedUser}
        options={userPermissionOptions}
        placeholder={t('userOrGroupPlaceholder')}
        onChange={setSelectedUser}
      />
      {selectedUserPermissions && (
        <PermissionEditor userPermissions={selectedUserPermissions} savePermission={handleSavePermission} />
      )}
    </>
  );
};
